import React from 'react';
import { Page } from '../Page';
import { SupplementCallout } from '../SupplementCallout';
export function PageChronicSideEffects() {
  return <Page pageNumber={35} variant="light" data-id="element-858">
      <div className="flex flex-col h-full" data-id="element-859">
        <div className="mb-8 pt-4" data-id="element-860">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-861">
            Side Effects
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-862">
            Chronic <span className="text-tealslate" data-id="element-863">Side Effects</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-864" />
        </div>

        <div className="mb-8" data-id="element-865">
          <p className="text-sm text-[#3B3B3B] leading-[1.8] max-w-2xl" data-id="element-866">
            While nausea and diarrhea usually fade as your body adapts to the
            medication, other side effects can persist or develop over time.
            These require ongoing management.
          </p>
        </div>

        {/* Mid-page Image Break */}
        <div className="h-[180px] -mx-12 mb-10 overflow-hidden relative" style={{
        width: 'calc(100% + 96px)'
      }} data-id="element-867">
          <img src="https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=1000&q=80" alt="Wellness" className="w-full h-full object-cover" data-id="element-868" />
        </div>

        <div className="grid grid-cols-2 gap-10 mb-8" data-id="element-869">
          <div data-id="element-870">
            <h2 className="text-xl font-serif text-[#1F1F1F] mb-3" data-id="element-871">
              Hair Loss
            </h2>
            <p className="text-xs text-[#7A7A70] leading-[1.8] mb-4" data-id="element-872">
              One of the most distressing side effects. Usually caused by rapid
              weight loss and inadequate protein/nutrient intake, not the
              medication itself.
            </p>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-873">
              <p className="text-[11px] text-[#3B3B3B] leading-[1.6]" data-id="element-874">
                <strong className="text-tealslate" data-id="element-875">Prevention:</strong> Adequate
                protein is non-negotiable. Supplementing with biotin, iron,
                zinc, and collagen can also support follicle health.
              </p>
            </div>
          </div>

          <div data-id="element-876">
            <h2 className="text-xl font-serif text-[#1F1F1F] mb-3" data-id="element-877">
              Muscle Loss
            </h2>
            <p className="text-xs text-[#7A7A70] leading-[1.8] mb-4" data-id="element-878">
              Without resistance training, up to 40% of weight lost can come
              from muscle. This lowers your metabolism and makes weight regain
              more likely.
            </p>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-879">
              <p className="text-[11px] text-[#3B3B3B] leading-[1.6]" data-id="element-880">
                <strong className="text-tealslate" data-id="element-881">Prevention:</strong> Adequate
                protein + weight lifting. This is why weight lifting is one of
                the 5 essentials.
              </p>
            </div>
          </div>
        </div>

        <div className="flex-1 flex items-end gap-6" data-id="element-882">
          <div className="flex-1" data-id="element-883">
            <SupplementCallout title="Hair and Recovery Support" description="Biotin, collagen peptides, and a quality multivitamin support hair health and recovery during rapid weight loss." data-id="element-884" />
          </div>
          <div className="flex-1 bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex items-center justify-between" data-id="element-885">
            <div data-id="element-886">
              <h3 className="font-serif text-sm text-[#1F1F1F] mb-1" data-id="element-887">
                Need a Program?
              </h3>
              <p className="text-[10px] text-[#7A7A70] leading-[1.5] max-w-[180px]" data-id="element-888">
                A structured resistance training program is the single most
                effective tool.
              </p>
            </div>
            <div className="w-10 h-10 border border-[#D8D8D0] bg-white flex items-center justify-center shrink-0" data-id="element-889">
              <span className="text-[8px] font-bold text-[#7A7A70]" data-id="element-890">QR</span>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}